import { nanoid } from 'nanoid'

/**
 * Generate a customer ID with the format: cust_<nanoid>
 * @returns A unique customer ID string
 */
export const generateCustomerId = (): string => {
  return `cust_${nanoid()}`
}

/**
 * Generate a pricing ID with the format: price_<nanoid>
 * @returns A unique pricing ID string
 */
export const generatePricingId = (): string => {
  return `price_${nanoid()}`
}

/**
 * Generate an order ID with the format: order_<nanoid>
 * @returns A unique order ID string
 */
export const generateOrderId = (): string => {
  return `order_${nanoid()}`
}

/**
 * Check if a string is a valid customer ID format
 * @param id The ID to validate
 * @returns True if the ID matches the customer ID format
 */
export const isValidCustomerId = (id: string): boolean => {
  return /^cust_[A-Za-z0-9_-]{21}$/.test(id)
}

/**
 * Check if a string is a valid pricing ID format
 * @param id The ID to validate
 * @returns True if the ID matches the pricing ID format
 */
export const isValidPricingId = (id: string): boolean => {
  return /^price_[A-Za-z0-9_-]{21}$/.test(id)
}
